import setupApolloClient from 'customer-flows/apollo'
import type ApplicationInstance from '@ember/application/instance'

export default {
  initialize(appInstance: ApplicationInstance) {
    setupApolloClient(appInstance)
  }
}
